import Rest from './rest';

const AUTH_RESOURCE = "auth";

export default {

    auth: function (objectParams) {
        return Rest.post(`${AUTH_RESOURCE}/login` , objectParams, false);
    },

    authInfo: function () {
        return Rest.get(`${AUTH_RESOURCE}/me`)
    },

    fbCustomToken: function () {
        return Rest.get(AUTH_RESOURCE + "/fbtoken")
    }

};



// WEBPACK FOOTER //
// ./src/services/AuthService.js